import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch, useSelector } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import { network } from '../AdminNetwork';
import Market from "../../ABI/market"
import Web3 from 'web3';
import { getadminuserdata, getuserdata, logout, updateAdminProfile } from '../../actions/users';
import { useNavigate } from 'react-router-dom';
import { wallet_connect_context } from '../../actions/redux/action';

const UserProfile = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [formValue, setFormValue] = useState({});
  const [validateError, setValidateError] = useState({});
  const [UserAccountAddr, Set_UserAccountAddr] = useState("");
  const [Accounts, Set_Accounts] = useState("");
  const [photoimage, setPhoto] = useState();

  const Wallet_Details = useSelector((state) => state.admin);
  
  useEffect(() => {
    getConnect()
    if(Wallet_Details?.UserAccountAddr!='')
      {
        getUserData();
        
      }
    }, [Wallet_Details?.UserAccountAddr])
    
    const getConnect = async () => {
      try {
          var configdata = {};
          if (window.ethereum) {
              var web3 = new Web3(window.ethereum);
              if (web3 !== undefined) {
                  await window.ethereum.enable().then(async function () {
                      const web3 = new Web3(window.web3.currentProvider);
                      if (window.web3.currentProvider.networkVersion === config.ETH_ID) {
                          var currentChainId = network.ETH.Chainid;
                          configdata = network.ETH;
                      } else if (window.web3.currentProvider.networkVersion === config.MATIC_ID) {
                          var currentChainId = network.MATIC.Chainid;
                          configdata = network.MATIC;
                      } else if (window.web3.currentProvider.networkVersion === config.CAM_ID) {
                          var currentChainId = network.CAM.Chainid;
                          configdata = network.CAM;
                      }
                      if (window.web3.currentProvider.networkVersion == currentChainId) {
                          if (window.web3.currentProvider.isMetaMask === true) {
                              var currAddr1 = await web3.eth.getAccounts();
                                  var currAddr = currAddr1[0].toLowerCase();
                              if (
                                  window.web3  && currAddr
                              ) {
                                  var CurAddr = String(currAddr).toLowerCase();
                                  Set_UserAccountAddr(CurAddr);
                                  var result = await web3.eth.getAccounts();
                                  var setacc = result[0];
                                  Set_Accounts(setacc);
                                  dispatch(wallet_connect_context({
                                      UserAccountAddr: setacc,
                                      WalletConnected: "true",
                                      Accounts: setacc,
                                      providerss: web3._provider,
                                      networkConfiguration: configdata,
                                  }));
                              }
                          }
                      } else {
                          toastAlert("error", "Please Connect Wallet");
                      }
                  });
              }
          }
      } catch (errr) {
          console.log("get connect", errr);
      }
  };
  
  const logoutuser = (e) => {
      logout(navigate);
          }

  const handleFormSubmit = async (e) => {
      e.preventDefault();
    if(window.ethereum){
      var web3 = new Web3(window.ethereum);
     
      if(web3&&web3.eth){
      var addrs = window?.web3?.eth?.defaultAccount;
      var currAddr = addrs?.toString()?.toLowerCase();
      const CoursetroContract = new web3.eth.Contract(Market, Wallet_Details.networkConfiguration.TradeContract);
      var adminAddress = await CoursetroContract.methods.owner().call();
      adminAddress = adminAddress.toLocaleLowerCase();
    
      if ( adminAddress !== currAddr) {
        toastAlert("update", 'Admin can only edit')
        return false;
      }
      var currAddress = adminAddress;
      let reqData = {
        email,
        mobilenumber,
        photo,
        company,
        designation,
        password,
        detail,
        currAddress,
        name
      }
      let data = await updateAdminProfile(reqData);
      if (data && data.microValue && data.microValue.data && data.microValue.data.Success === true) {
        setValidateError("");
        toastAlert("success", 'Profile updated Successfully');
        logoutuser()
        getUserData();
      } else {
        setValidateError('Error Occured');
      }
    }
    }
    else{
      toastAlert("update", "Connect metamask")
    }
  }

  const getUserData = async () => { 
    try {
      var adminAddress=""
  var web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);
    if(web3){
  
      const CoursetroContract = new web3.eth.Contract(Market, Wallet_Details.networkConfiguration.TradeContract);
      adminAddress = await CoursetroContract.methods.owner().call();
      adminAddress = adminAddress.toLocaleLowerCase();
      config.adminAddress=adminAddress
    }
      var postadata={
        currAddr : adminAddress
      }
    var test = await getadminuserdata(postadata);
  
    let formdata = {};
  
    if(test && test.adminData && test.adminData.userValue){
      var data = test.adminData;
      formdata['email'] = data.userValue.email;
      formdata['mobilenumber'] = data.userValue.phoneNo;
      formdata['designation'] = data.userValue.designation;
      formdata['detail'] = data.userValue.about;
      formdata['company'] = data.userValue.company;
      formdata['password'] = data.userValue.normalPassword;
      formdata['name'] = data.userValue.name;
      formdata['adminAddress'] = data.userValue.adminAddress;
      setPhoto(data.userValue.profileImage);
      setFormValue(formdata);
    }
    } catch (error) {
      console.log("errorgetUserData", error);  
    }
  
  }

  const onChange = (e) => {
      e.preventDefault();
      const { id, value } = e.target;
      let formData = { ...formValue, ...{ [id]: value } }
      setFormValue(formData)
  }

  const {
    email,
    mobilenumber,
    photo,
    company,
    designation,
    password,
    detail,
    name,adminAddress
  } = formValue

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Admin Profile'} />
            <div className='common_page_scroller mt-5 pe-2'>
              <form noValidate autoComplete="off">
                <div color="primary" className="addcategorys mb-3">
                  <h4>Admin Profile</h4>
                </div>
                <div className="categorylisdt">
                <div className='row'>
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="company">Company</label>
                        <input
                        className='form-control'
                          type="text"
                          id="company"
                          value={company || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                        {validateError.company && <span>{validateError.company}</span>}
                      </div>
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="name">Name</label>
                        <input
                        className='form-control'
                          type="text"
                          id="name"
                          value={name || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                        {validateError.name && <span>{validateError.name}</span>}
                      </div>
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="email">Email address</label>
                        <input
                        className='form-control'
                          type="email"
                          id="email"
                          value={email || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                        {validateError.email && <span>{validateError.email}</span>}
                      </div>
                 
                  
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="mobilenumber">Mobile</label>
                        <input
                        className='form-control'
                          type="text"
                          id="mobilenumber"
                          value={mobilenumber || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                        {validateError.mobilenumber && <span>{validateError.mobilenumber}</span>}
                      </div>
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="designation">Designation</label>
                        <input
                        className='form-control'
                          type="text"
                          id="designation"
                          value={designation || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                        {validateError.designation && <span>{validateError.designation}</span>}
                      </div>
                      <div className='col-xl-6 mb-3'>
                        <label htmlFor="password">Password</label>
                        <input
                        className='form-control'
                          type="password"
                          id="password"
                          value={password || ""}
                          onChange={onChange}
                          style={{ width: '100%' }}
                        />
                      </div>
                  
                 
                      <div className='col-xl-6 mb-3'>
                        <input
                        className='form-control'
                          type="text"
                          id="adminAddress"
                          value={config.adminaddress || adminAddress}
                          style={{ width: '100%' }}
                          disabled
                        />
                        <p className='text-white mt-2'>Admin fee called from contract</p>
                      </div>
                      </div>
                </div>
                <div>
                  <button type='button' className='btn addcate mt-3 mb-4 ms-2'  onClick={handleFormSubmit}>Update Profile</button>
                </div>
              </form>

            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default UserProfile